<template>
  <div class="user-group">
    <ul class="group-list">
      <li :class="['group-list-item', checkGroup.id === undefined ? 'active' : '']" @click.self="getUser(0)">
        <!-- <i v-show="isEdit" class="iconfont icon-tuodong"></i> -->
        最近选择
      </li>
      <VueDraggable v-if="userGruoupList.length > 0" v-model="userGruoupList" item-key="icon-tuodong" handle=".icon-tuodong" animation="300" @end="draggableEnd">
        <transition-group>
          <li 
            v-for="item in userGruoupList" 
            :class="['group-list-item', checkGroup.id === item.id ? 'active' : '']"  
            :key="item.id" 
            @click.self="getUser(1, item)">
            <i v-show="isEdit" class="iconfont icon-tuodong"></i>
            <el-input 
              v-if="isEditName && checkGroup.id === item.id" 
              v-model="item.name" style="width: 100px;" 
              size="mini" 
              @focus.stop="prevent($event)"
              @blur="editGroup(item)"></el-input>
            <span v-else>
              <el-checkbox v-model="item.checked" @change="val => { groupChange(item, val) }">{{ item.name }}</el-checkbox>
            </span>
            <span class="btns" v-show="isEdit">
              <i @click="isEditName = true" class="iconfont icon-bianji"></i>
              <i @click.stop="delGroup(item.id)" class="iconfont icon-a-shanchu2x"></i>
            </span>
          </li>
        </transition-group>
      </VueDraggable>
    </ul>
  </div>
</template>

<script>
import {
  getuserfolderlist,
  batchupdateuserfolderorders,
  updateuserfolder,
  deleteuserfolder
} from '@/port/admins/relationUserGroup'
export default {
  name: 'groupChoice',
  data () {
    return {
      userArr: [],
      userGruoupList: [],
      checkGroup: {},
      isEditName: false
    }
  },
  props: {
    approvalId: {},
    isEdit: {
      type: Boolean,
      default: false
    },
    // 是否是通知对象打开
    isCto: {
      type: Boolean,
      default: false
    },
    checkedGroupArr: {
      type: Array,
      default: () => { return [] }
    },
    isGroup: {
      type: Boolean,
      default: false
    },
    isGrouping: {
      type: Number,
      default: 0
    }
  },
  components: {
  },
  methods: {
    groupChange (item) {
      this.$emit('handleSelectGroup', item)
    },
    deleteCheck (val) {
      const index = this.userGruoupList.findIndex(item => { return item.id === val.id })
      if (index !== -1) {
        this.userGruoupList[index].checked = false
        this.groupChange(this.userGruoupList[index])
      }
    },
    prevent (event) {
      event.stopPropagation() 
    },
    async delGroup (id) {
      const { code, msg } = await deleteuserfolder({id})
      if (code === 0) {
        this.getGroup()
      } else {
        this.$message.error(msg)
      }
    },
    async editGroup (val) {
      const query = {
        id: val.id,
        name: val.name
      }
      const { code, msg } = await updateuserfolder(query)
      if (code !== 0) this.$message.error(msg)
      this.isEditName = false
    },
    async getUser (key, item = {}) {
      this.checkGroup = item
      const payload = key === 0 ?
      {
        approvalId: this.approvalId,
        curpage: 1,
        pagesize: 100
      } : 
      {
        id: item.id,
        name: item.name,
        curpage: 1,
        pagesize: 100,
      }
      this.$emit('handleSelect', key, payload)
    },
    // 获取分组
    async getGroup (checkFirst) {
      const obj = {
        curpage: 0,
        pagesize: 0
      }
      if(this.isGrouping === 1){
        obj.approvalId = this.approvalId
      }
      const { code, data } = await getuserfolderlist(obj)
      if (code === 0) {
        this.userGruoupList = !this.isCto ? data : data.map(item => {
          const index = this.checkedGroupArr.findIndex(iten => { return item.id === iten.id })
          item.checked = index !== -1 ? true : false
          return item
        })
        if (checkFirst) this.getUser(1, data[0])
      }
    },

    // 分组拖拽结束
    async draggableEnd () {
      const arrLen = this.userGruoupList.length
      const arr = this.userGruoupList.map((item, index) => {
          return {
            id: item.id,
            orders: arrLen - index,
          }
        })
      const { code, msg } = await batchupdateuserfolderorders({ parameters: arr })
      if (code !== 0) this.$message.error(msg)
    }
  },
  mounted () {
    // this.getUser(0)
    if (this.isGroup) this.getGroup()
  }
}
</script>

<style lang="scss" scoped>
.user-group {
  width: 100%;
  height: 100%;
  position: relative;
  .group-list {
    width: 100%;
    height: 100%;
    overflow: auto;
    &-item {
      position: relative;
      height: 32px;
      line-height: 32px;
      cursor: pointer;
      padding-left: 30px;
      .btns {
        position: absolute;
        right: 10px;
        font-size: 14px;
      }
      .icon-tuodong {
        font-size: 12px;
        position: absolute;
        left: 10px;
      }
      &:hover {
        background-color: #F5F7FA;
      }
      
    }
    .active {
      background-color: #f1f5ff;
    }
  }
}
</style>